<template>
  <div
    class="aside-container"
    :class="{'collapse-aside':isCollapseAside}"
  >
    <div class="header-left">
      <img
        class="header-logo"
        src="@/assets/photos/smartLogo.png"
        alt="信瑞logo"
        @click="toOurWebsite"
      >
      <span
        v-show="!isCollapseAside"
        class="header-title"
        @click="backHome"
      >
        5G急救车信息系统
      </span>
    </div>
    <!--  侧边栏完整  -->
    <div v-show="!isCollapseAside">
      <div class="connectStatus">
        <div
          v-for="item in ambulanceList"
          :key="item.id + ''"
          class="checkConnection"
        >
          <span>{{ item.name }}</span>
          <div>
            <span v-if="showConnectStatus[item.id]" class="connected"/>
            <span v-else class="disconnection"/>
          </div>
        </div>
      </div>
      <div class="aside-menu">
        <div
          v-for="item in ambulanceList"
          :key="item.id + ''"
          class="sub-menu-list"
        >
          <!-- 急救车列表 -->
          <div
            class="carNameList menu"
            :class="{ 'is-active': isShowCarMenus['isSelectedCar' + item.id] }"
          >
            <div class="icon-aside-car"/>
            <span
              class="carName"
              @click="showCarItem(item.id)"
            >
              {{ item.name }}-{{ item.idName }}
            </span>
          </div>
          <!-- 急救车事件 -->
          <div
            :id="'isShowCarMenus' + item.id"
            class="carNameItem"
            :class="[isShowCarMenus['isShowCarItem' + item.id] ? 'showListItem' :'hideListItem']"
          >
            <div
              class="recognition"
              :class="{ 'is-active-item': isShowCarMenus['isShowCarRecognition' + item.id], 'room-empty':!checkHasRoom(item.id) }"
              @click="showRecognition(item.id)"
            >
              车前急救
            </div>
            <div
              class="liveCondition"
              :class="{ 'is-active-item': isShowCarMenus['liveCarCondition' + item.id] }"
              @click="showLiveCondition(item.id)"
            >
              急救实况
              <i v-show="showAssistant(item.id)" class="el-icon-chat-dot-round"/>
            </div>
            <div
              class="navigation"
              :class="{ 'is-active-item': isShowCarMenus['isShowCarNavigation' + item.id] }"
              @click="showNavigation(item.id)"
            >
              导航
            </div>
          </div>
        </div>
        <div
          v-for="item in planeList"
          :key="item.id + ''"
          class="sub-menu-list"
        >
          <div
            class="carNameList menu"
            :class="{ 'is-active': isShowPlaneMenus['isSelectedPlane' + item.id] }"
          >
            <div class="icon-aside-plane"/>

            <span
              class="carName"
              @click="showPlaneItem(item.id)"
            >
              无人机{{ item.id }}号
            </span>
          </div>
          <div
            :id="'isShowPlaneMenus' + item.id"
            class="carNameItem"
            :class="[isShowPlaneMenus['isShowPlaneItem' + item.id] ? 'showListItem' :'hideListItem']"
          >
            <div
              class="liveCondition"
              :class="{ 'is-active-item': isShowPlaneMenus['isShowPlaneLive' + item.id] }"
              @click="showPlaneLiveCondition(item.id)"
            >
              急救实况
            </div>
            <div
              class="recognition"
              :class="{ 'is-active-item': isShowPlaneMenus['isShowPlaneNavigation' + item.id] }"
              @click="showPlaneRecognition(item.id)"
            >
              导航定位
            </div>
          </div>
        </div>
        <div
          v-for="item in autoCarList"
          :key="item.id + ''"
          class="sub-menu-list"
        >
          <div
            class="carNameList menu"
            :class="{ 'is-active': isShowAutoMobileMenus['isSelectedAutoMobile' + item.id] }"
          >
            <div class="icon-aside-car"/>
            <span
              class="carName"
              @click="showAutoMobileItem(item.id)"
            >
              无人车{{ item.id }}号
            </span>
          </div>
          <!-- 无人机事件 -->
          <div
            :id="'isShowAutoMobileMenus' + item.id"
            class="carNameItem"
            :class="[isShowAutoMobileMenus['isShowAutoMobileItem' + item.id] ? 'showListItem' :'hideListItem']"
          >
            <div
              class="liveCondition"
              :class="{ 'is-active-item': isShowAutoMobileMenus['isShowAutoMobileLive' + item.id] }"
              @click="showAutoMobileLiveCondition(item.id)"
            >
              急救实况
            </div>
            <div
              class="recognition"
              :class="{ 'is-active-item': isShowAutoMobileMenus['isShowAutoMobileNavigation' + item.id] }"
              @click="showAutoMobileRecognition(item.id)"
            >
              导航定位
            </div>
          </div>
        </div>
        <div
          class="sub-menu-list"
        >
          <!--信息管理列表 -->
          <div
            class="carNameList menu"
            :class="{ 'is-active': isShowManageMenus['isSelectedManage'] }"
          >
            <div class="icon-aside-info"/>
            <span
              class="carName"
              @click="showManageItem"
            >
              信息管理
            </span>
          </div>
          <div
            :id="'isShowManageMenus'"
            class="carNameItem"
            :class="[isShowManageMenus['isShowManageItem'] ? 'showListItem' :'hideListItem']"
          >
            <div
              class="liveCondition"
              :class="{ 'is-active-item': isShowManageMenus['isShowManageCase'] }"
              @click="showManageCase"
            >
              急救事例
            </div>
            <div
              v-show="false"
              class="recognition room-empty"
              :class="{ 'is-active-item': isShowManageMenus['isShowManageGuiding'] }"
              @click="showManageGuiding"
            >
              急救指引
            </div>
          </div>
        </div>

        <div
          class="sub-menu-list"
        >
          <!--设置列表 -->
          <div
            class="carNameList menu"
            :class="{ 'is-active': isShowSettingMenus['isSelectedSetting'] }"
          >
            <div class="icon-aside-setting"/>
            <span
              class="carName"
              @click="showSettingItem"
            >
              设置
            </span>
          </div>
          <div
            :id="'isShowSettingMenus'"
            class="carNameItem"
            :class="[isShowSettingMenus['isShowSettingItem'] ? 'showListItem' :'hideListItem']"
          >
            <div
              class="liveCondition"
              :class="{ 'is-active-item': isShowSettingMenus['isShowSettingUser'] }"
              @click="showSettingUser"
            >
              用户设置
            </div>
            <div
              class="recognition"
              :class="{ 'is-active-item': isShowSettingMenus['isShowSettingSchedule'] }"
              @click="showSettingSchedule"
            >
              排班设置
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  侧边栏收缩  -->
    <div v-if="isCollapseAside">
      <div class="connectStatus">
        <div
          v-for="item in ambulanceList"
          :key="item.id + ''"
          class="checkConnection"
        >
          <!--          <span>{{ item.name }}</span>-->
          <!--         fixme short name-->
          <span>N车</span>
          <div>
            <span v-if="showConnectStatus[item.id]" class="connected"/>
            <span v-else class="disconnection"/>
          </div>
        </div>
      </div>
      <div class="aside-menu">
        <div
          v-for="item in ambulanceList"
          :key="item.id + ''"
          class="sub-menu-list"
        >
          <!-- 急救车列表 -->
          <div
            class="carNameList menu"
            :class="{ 'is-active': isShowCarMenus['isSelectedCar' + item.id] }"
            @click="showCarItem(item.id)"
          >
            <div class="icon-aside-car"/>
          </div>
          <!-- 急救车事件 -->
          <div
            :id="'isShowCarMenus' + item.id"
            class="carNameItem"
            :class="[isShowCarMenus['isShowCarItem' + item.id] ? 'showListItem' :'hideListItem']"
          >
            <div
              class="recognition"
              :class="{ 'is-active-item': isShowCarMenus['isShowCarRecognition' + item.id] }"
              @click="showRecognition(item.id)"
            >
              车前急救
            </div>
            <div
              class="liveCondition"
              :class="{ 'is-active-item': isShowCarMenus['liveCarCondition' + item.id] }"
              @click="showLiveCondition(item.id)"
            >
              急救实况
            </div>
            <div
              class="navigation"
              :class="{ 'is-active-item': isShowCarMenus['isShowCarNavigation' + item.id] }"
              @click="showNavigation(item.id)"
            >
              导航
            </div>
          </div>
        </div>
        <div
          v-for="item in planeList"
          :key="item.id + ''"
          class="sub-menu-list"
        >
          <div
            class="carNameList menu"
            :class="{ 'is-active': isShowPlaneMenus['isSelectedPlane' + item.id] }"
            @click="showPlaneItem(item.id)"
          >
            <div class="icon-aside-plane"/>
          </div>
          <div
            :id="'isShowPlaneMenus' + item.id"
            class="carNameItem"
            :class="[isShowPlaneMenus['isShowPlaneItem' + item.id] ? 'showListItem' :'hideListItem']"
          >
            <div
              class="liveCondition"
              :class="{ 'is-active-item': isShowPlaneMenus['isShowPlaneLive' + item.id] }"
              @click="showPlaneLiveCondition(item.id)"
            >
              急救实况
            </div>
            <div
              class="recognition"
              :class="{ 'is-active-item': isShowPlaneMenus['isShowPlaneNavigation' + item.id] }"
              @click="showPlaneRecognition(item.id)"
            >
              导航定位
            </div>
          </div>
        </div>
        <div
          v-for="item in autoCarList"
          :key="item.id + ''"
          class="sub-menu-list"
        >
          <div
            class="carNameList menu"
            :class="{ 'is-active': isShowAutoMobileMenus['isSelectedAutoMobile' + item.id] }"
            @click="showAutoMobileItem(item.id)"
          >
            <div class="icon-aside-car"/>
          </div>
          <div
            :id="'isShowAutoMobileMenus' + item.id"
            class="carNameItem"
            :class="[isShowAutoMobileMenus['isShowAutoMobileItem' + item.id] ? 'showListItem' :'hideListItem']"
          >
            <div
              class="liveCondition"
              :class="{ 'is-active-item': isShowAutoMobileMenus['isShowAutoMobileLive' + item.id] }"
              @click="showAutoMobileLiveCondition(item.id)"
            >
              急救实况
            </div>
            <div
              class="recognition"
              :class="{ 'is-active-item': isShowAutoMobileMenus['isShowAutoMobileNavigation' + item.id] }"
              @click="showAutoMobileRecognition(item.id)"
            >
              导航定位
            </div>
          </div>
        </div>
        <div
          class="sub-menu-list"
        >
          <!--信息管理列表 -->
          <div
            class="carNameList menu"
            :class="{ 'is-active': isShowManageMenus['isSelectedManage'] }"
            @click="showManageItem"
          >
            <div class="icon-aside-info"/>
          </div>
          <div
            :id="'isShowManageMenus'"
            class="carNameItem"
            :class="[isShowManageMenus['isShowManageItem'] ? 'showListItem' :'hideListItem']"
          >
            <div
              class="liveCondition"
              :class="{ 'is-active-item': isShowManageMenus['isShowManageCase'] }"
              @click="showManageCase"
            >
              急救事例
            </div>
            <div
              class="recognition room-empty"
              :class="{ 'is-active-item': isShowManageMenus['isShowManageGuiding'] }"
              @click="showManageGuiding"
            >
              急救指引
            </div>
          </div>
        </div>

        <div
          class="sub-menu-list"
        >
          <!--设置列表 -->
          <div
            class="carNameList menu"
            :class="{ 'is-active': isShowSettingMenus['isSelectedSetting'] }"
            @click="showSettingItem"
          >
            <div class="icon-aside-setting"/>
          </div>
          <div
            :id="'isShowSettingMenus'"
            class="carNameItem"
            :class="[isShowSettingMenus['isShowSettingItem'] ? 'showListItem' :'hideListItem']"
          >
            <div
              class="liveCondition"
              :class="{ 'is-active-item': isShowSettingMenus['isShowSettingUser'] }"
              @click="showSettingUser"
            >
              用户设置
            </div>
            <div
              class="recognition"
              :class="{ 'is-active-item': isShowSettingMenus['isShowSettingSchedule'] }"
              @click="showSettingSchedule"
            >
              排班设置
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 急救车列表展示完毕 -->
    <slot name="arrow"/>

    <small-dialog :dialog-show="disConnectDialog" @closeDialog="disConnectDialog=false">
      <div>急救车{{ disconnectCarName }} 的设备未连接，请检查！</div>
    </small-dialog>
    <small-dialog :dialog-show="startTip" @closeDialog="startTip=false">
      <div>{{ sentCarName }}发车了！</div>
    </small-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SmallDialog from "@/components/customDialog/SmallDialog";
import tool from "@components/asides/tool";
import { finishInviteAssistant } from "@api/user";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "Aside",
  components: {
    SmallDialog
  },
  mixins: [tool],
  emits: ["toHideTags"],
  data() {
    return {
      showConnectStatus: {}, // 急救车设备连接情况
      disconnectCarName: "", // 设备未连接的车牌号码
      sentCarName: "", // 发车的 车牌名字
      lastTimeCarConnectStatus: {},
      disConnectDialog: false, // 设备未连接提示框
      startTip: false, /* 车来了提示框 */
      // 无人车 无人机 急救车三者结构类似
      isShowPlaneMenus: {},
      isShowAutoMobileMenus: {},
      isShowCarMenus: {},
      isShowManageMenus: {
        isShowManageItem: false, //  是否展信息管理具体项目
        isSelectedManage: false, //  是否展开无人车一级菜单被选中
        isShowManageCase: false, //  急救事例
        isShowManageGuiding: false, //  急救指引
      },
      isShowSettingMenus: {
        isShowSettingItem: false, // 是否展开设置具体项目
        isSelectedSetting: false, // 是否展开设置一级菜单被选中
        isShowSettingUser: false, // 用户设置
        isShowSettingSchedule: false, // 排班设置
      },

    };
  },
  computed: {
    ...mapState({
      userInfo: "userInfo",
      carObject: "carObject",
      isCollapseAside: "isCollapseAside",
      assistMessage: "assistMessage",
      tencentRoomStatus: "tencentRoomStatus",
      currentList: "currentList"
    }),
  },
  watch: {
    $route(to) {
      const { query } = to;
      // 路由进来之时,首先清空所有的侧边栏样式
      this.clearActiveStyle();
      // 再根据url参数, 重新恢复
      this.dealUrl(query);
    }
  },

  mounted() {
    this.dealUrl(this.$route.query);
    this.getHospitalListAndStyle(); // 挂载之后请求相关数据,跟watch的区分就是, watch下的不会弹出连接错误提示框
  },

  methods: {
    showAssistant(id) {
      const item = this.assistMessage.find(({ ambulance_id }) => {
        return ambulance_id === id;
      });
      return !!item;
    },
    backHome() {
      this.$router.push("/index");
    },
    // 点击进入官网
    toOurWebsite() {
      window.location.href = "https://www.thearay.com/";
    },
    checkHasRoom(id) {
      const currentMission = this.currentList.find((item) => {
        return item.ambulanceId === id;
      });
      if (currentMission) {
        const number = currentMission.number + "1";
        const roomId = number.slice(2) * 1;
        return this.tencentRoomStatus[roomId];
      } else {
        return false;
      }
    },
    /*
    * 车前急救 如果房间没有开, 不准进入
    * */
    showRecognition(id) {
      const isTrue = this.checkHasRoom(id);
      if (isTrue) {
        this.routeSettingHandler(id, "isShowCarRecognition", "/HelpBeforeArrival/", this.isShowCarMenus, "car", "车前");
      }
    },
    // 急救实况
    async showLiveCondition(id) {
      // console.log("---- live condition--");
      // return
      // if there are any invite messages, delete the announce
      const itemIndex = this.assistMessage.findIndex(({ ambulance_id }) => ambulance_id === id);
      if (itemIndex !== -1) {
        const item = this.assistMessage[itemIndex];
        try {
          const { code, msg } = await finishInviteAssistant(JSON.stringify({ id: item.id }));
          if (code !== 200) {
            showWindowMessage(3, msg, this);
          }
          this.assistMessage.splice(itemIndex, 1);
          this.$store.commit("updateAssistMessage", this.assistMessage);
        } catch (e) {
          showWindowMessage(3, e, this);
        }
      }
      // 发送给服务器请求, 完成通话协助 邀请请求
      // 急救实况
      this.routeSettingHandler(id, "liveCarCondition", "/showAmbulance/", this.isShowCarMenus, "car", "实况");
    },
    showNavigation(id) {
      // 导航
      this.routeSettingHandler(id, "isShowCarNavigation", "/Navigation/", this.isShowCarMenus, "car", "导航");
    },
    showPlaneRecognition(id) {
      // 导航定位
      this.routeSettingHandler(id, "isShowPlaneNavigation", "/planeNavigation/", this.isShowPlaneMenus, "Plane", "导航");
    },
    showPlaneLiveCondition(id) {
      // 急救实况
      this.routeSettingHandler(id, "isShowPlaneLive", "/planeLive/", this.isShowPlaneMenus, "Plane", "定位");
    },
    showAutoMobileRecognition(id) {
      // 导航定位
      this.routeSettingHandler(id, "isShowAutoMobileNavigation", "/autoMobileNavigation/", this.isShowAutoMobileMenus, "autoMobile", "导航");
    },
    showAutoMobileLiveCondition(id) {
      // 急救实况
      this.routeSettingHandler(id, "isShowAutoMobileLive", "/autoMobileLive/", this.isShowAutoMobileMenus, "autoMobile", "定位");
    },

    showManageCase() {
      this.showMenuItem("isShowManageCase", "/isShowManageCase/", "急救事例", "manage");
    },

    showCarItem(id) {
      this.toggleItemMenus("Car", id);
    },

    showPlaneItem(id) {
      this.toggleItemMenus("Plane", id);
    },

    showAutoMobileItem(id) {
      this.toggleItemMenus("AutoMobile", id);
    },

    showManageItem() {
      this.toggleItemMenus("Manage", "");
    },

    showSettingItem() {
      this.toggleItemMenus("Setting", "");
    },
    showManageGuiding() {
      return false;
      this.showMenuItem(
        "isShowManageGuiding",
        "/guiding/",
        "急救指引",
        "manage"
      );
    },

    showSettingUser() {
      this.showMenuItem(
        "isShowSettingUser",
        "/setting/",
        "用户设置",
        "setting"
      );
    },

    showSettingSchedule() {
      this.showMenuItem(
        "isShowSettingSchedule",
        "/settingSchedule/",
        "排班设置",
        "setting"
      );
    },

  },
};
</script>
<style scoped lang="scss">
.header-left {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-title {
    font-size: 20px;
    font-weight: bold;
    color: #FBFBFB;
  }
}

.aside-container {
  background: url(../../assets/photos/aside-bg.png) 100% 100% no-repeat #75B8E6;
  user-select: none;
  cursor: pointer;
  float: left;
  height: calc(100% - 40px);
  position: relative;
  border-radius: 0 16px 16px 0;
  padding: 20px;
  margin-right: 20px;

  .el-col-24 {
    width: 100%;
  }

  .aside-menu {
    overflow: auto;
    width: 220px;
  }
}

.collapse-aside {
  width: 70px;
  padding: 20px 0;

  .connectStatus {
    padding: 0;
    border-radius: 0 10px 10px 0;
  }

  div.checkConnection {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .aside-menu {
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .header-left {
    width: 70px;
    display: flex;
    justify-content: center;
  }
}

.connectStatus {
  margin-top: 36px;
  margin-bottom: 30px;
  border-radius: 10px;
  padding: 14px 24px;
  letter-spacing: 2px;
  font-size: 16px;
  color: #666666;
  background: url(../../assets/photos/checkConnection-bg.png) 100% 100% no-repeat #FBFBFB;

  .checkConnection {
    display: flex;
    justify-content: space-between;
    line-height: 30px;

    span.connected,
    span.disconnection {
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      vertical-align: middle;
    }
  }

  .connected {
    background: #79EB7B;
  }

  .disconnection {
    background: #EB7979;
  }
}

.sub-menu-list {
  letter-spacing: 2px;

  .carNameList {
    height: 58px;
    line-height: 58px;
    letter-spacing: 0;
  }

  .carNameList + div {
    font-size: 16px;
    font-weight: 400;
    color: #FBFBFB;
  }
}

.menu {
  display: flex;
  align-items: center;

  .carName {
    flex: 1;
    font-size: 18px;
    color: #FBFBFB;
  }
}

.is-active-item {
  font-size: 16px;
  font-weight: 400;
  color: #0A7AB3;
}

.is-active.menu {
  .icon-aside-car {
    background: url(../../assets/photos2/menu/car-select.png) center center no-repeat;
  }

  .icon-aside-plane {
    background: url(../../assets/photos2/menu/plane-select.png) center center no-repeat;
  }

  .icon-aside-info {
    background: url(../../assets/photos2/menu/info-select.png) center center no-repeat;
  }

  .icon-aside-setting {
    background: url(../../assets/photos2/menu/setting-select.png) center center no-repeat;
  }
}

.aside-menu {
  [class^=icon-aside-] {
    width: 36px;
    height: 36px;
  }

  .icon-aside-car {
    background: url(../../assets/photos2/menu/car-normal.png) center center no-repeat;
  }

  .icon-aside-car + span {
    padding-top: 3px;
  }

  .icon-aside-plane {
    background: url(../../assets/photos2/menu/plane-normal.png) center center no-repeat;
  }

  .icon-aside-info {
    background: url(../../assets/photos2/menu/info-normal.png) center center no-repeat;
  }

  .icon-aside-setting {
    background: url(../../assets/photos2/menu/setting-normal.png) center center no-repeat;
  }
}

.carNameItem > div {
  margin-left: 36px;
  height: 40px;
  line-height: 40px;
}

.hideListItem {
  display: none;
}

.showListItem {
  display: block;
}

.recognition.room-empty {
  opacity: 0.5;
}
</style>
